// extracted by mini-css-extract-plugin
module.exports = {"tnc-wrapper":"_218S-E_7ywTA7Du-PAuL4Z"};